import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../config";
import { SubmitButton } from "../../components/Input";
import { showToast } from "../../components/toast";

const AddMediaUpload = () => {
  const [file, setFile] = useState(null);
  const [path, setPath] = useState("media/email");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file || !path || !name) {
      showToast.error("Please provide file, path and name");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("path", path);
    formData.append("name", name);

    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}media-upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.status) {
        showToast.success(response.data.message || "Media uploaded successfully");
        navigate("/Settings/MediaUpload");
      } else {
        showToast.error(response.data.message || "Failed to upload");
      }
    } catch (err) {
      showToast.error(err.response?.data?.message || err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="panel panel-default with-rounded-corner with-shadow mt-5">
      <div className="panel-heading border-0">
        <span className="panel-title">Add Media Upload</span>
      </div>
      <div className="panel-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-2">
              <label className="control-label">Upload File</label>
              <input
                type="file"
                className="form-control"
                onChange={(e) => setFile(e.target.files[0])}
                required
              />
            </div>
            <div className="col-md-6 mb-2">
              <label className="control-label">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="col-md-6 mb-2">
              <label className="control-label">Path</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter path"
                value={path}
                onChange={(e) => setPath(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <SubmitButton
                pageBack={"/Settings/MediaUpload"}
                handleSubmit={handleSubmit}
                loading={loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMediaUpload;
